export const getModeOfLocation = () => {
  const location = window.location.pathname;
  const isEditMode = location.startsWith("/explorations/firebase/edit");
  const isViewMode = location.startsWith("/explorations/firebase/share") || location.includes("/firebase/show");
  return { isEditMode, isViewMode };
};
